var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('defaultVue',{ref:"defaultVue",attrs:{"supplierId":_vm.supplierId,"submitType":_vm.submitType},on:{"approval-status-change":_vm.onApprovalStatusChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }